// extracted by mini-css-extract-plugin
export default {"backToTopButton":"backToTopButton_35hR","backToTopButtonShow":"backToTopButtonShow_18ls"};